import React from 'react';
import { Lock, Heart, Scale, MessageSquare, ArrowRightLeft } from 'lucide-react';

const expectations = [
  {
    icon: Lock,
    title: 'Confidentiality',
    description: 'No approach to staff, customers, or suppliers without consent.',
  },
  {
    icon: Heart,
    title: 'Team Respect',
    description: 'Stability creates value. No day-one restructuring.',
  },
  {
    icon: Scale,
    title: 'Fair Valuation',
    description: 'Clear financial logic. Independent advice encouraged.',
  },
  {
    icon: MessageSquare,
    title: 'Direct Communication',
    description: 'No auction tactics or artificial deadlines.',
  },
  {
    icon: ArrowRightLeft,
    title: 'Practical Transition',
    description: 'Designed around your preferred exit timeline.',
  },
];

const WhatSellersExpect = () => {
  return (
    <section 
      id="expectations" 
      className="py-16 px-6 bg-section-light"
      data-testid="expectations-section"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="text-[2rem] md:text-[2.5rem] font-bold text-[#1a1a1a] mb-8 tracking-tight text-center">
          What Sellers Can Expect
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {expectations.map((item, index) => (
            <div 
              key={index}
              className="section-card p-4 text-center"
              data-testid={`expectation-item-${index}`}
            >
              <div className="w-10 h-10 rounded-lg bg-[#1e3a5f] flex items-center justify-center mx-auto mb-3">
                <item.icon className="w-5 h-5 text-white" />
              </div>
              <h3 className="text-sm font-semibold text-[#1a1a1a] mb-1">
                {item.title}
              </h3>
              <p className="text-[#5a5a5a] text-xs leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatSellersExpect;
